import type { MysteryAcceptor } from '@core/Data/Racing'
import type { MysterySelection } from '@mobi/betslip/types'
import type { NoveltySelections } from '@core/Areas/Quickbet/Components/BetSelectionInfo/types'
import { parseRawNoveltySelectionString } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/BetInfoHeader/helpers'

export function parseMysterySelectionString(
  selectionString: string,
  isAllways: boolean,
  acceptorsForRace: MysteryAcceptor[]
): NoveltySelections {
  return parseRawNoveltySelectionString({
    selectionString,
    isAllways,
    isLegIn: false,
    isRovingBanker: false,
    acceptorsForRace,
  })
}

export function getAcceptorsFromMysteryBetLine(
  betLine: NonNullable<MysterySelection['bets']>[0]['betLines'][0]
) {
  let jointArray: MysteryAcceptor[] = []

  betLine.legs.forEach(array => {
    jointArray = jointArray.concat(array.acceptors).concat(array.acceptors)
  })

  const uniqueArray = jointArray.reduce(
    (accumulator: MysteryAcceptor[], acceptor: MysteryAcceptor) => {
      if (accumulator.includes(acceptor)) {
        return accumulator
      } else {
        return [...accumulator, acceptor]
      }
    },
    []
  )
  return uniqueArray
}
